import { Box, Button } from '@mui/material';
import React from 'react';
import RoadMapEffect from '../../components/RoadMapEffect';
import MapCard from '../../components/mapCard';
import Banner from '../../components/banner';
import LocalGroceryStoreIcon from '@mui/icons-material/LocalGroceryStore';
import { makeStyles } from '@mui/styles';

const Home = () => {
  const classes = useStyles();

  return (
    <Box
      sx={{
        padding: {
          lg: '0rem 4rem',
          md: '0rem 4rem',
          sm: '0rem 2rem',
          xs: '0rem 1rem',
        },
      }}
    >
      <Box
        className={classes.btnContainer}
        sx={{
          paddingTop: { lg: '400px', md: '250px', sm: '200px', xs: '300px' },
          paddingBottom: { lg: '0px', md: '0px', sm: '100px', xs: '100px' },
        }}
      >
        <Button
          startIcon={<LocalGroceryStoreIcon />}
          className={classes.button}
          sx={{
            padding: {
              lg: '25px 125px !important',
              md: '15px 80px !important',
              sm: '10px 60px !important',
              xs: '10px 40px !important',
            },
          }}
        >
          buy the crypto
        </Button>
      </Box>
      <Box
        sx={{
          padding: { lg: '300px 0px 0 0' },
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
        }}
      >
        <RoadMapEffect />
      </Box>

      <Box>
        <MapCard />
      </Box>
      <Box
        sx={{
          padding: { lg: '60px 0px', md: '40px 0', sm: '20px 0', xs: '20px 0' },
        }}
      >
        <Banner />
      </Box>
    </Box>
  );
};

export default Home;
const useStyles = makeStyles((theme) => ({
  mainContainer: {
    backgroundColor: '#E4D2BA',
    boxShadow: '0 8px 15px rgba(0, 0, 0, 0.3)',
    padding: '40px 10px',
    borderRadius: '10px',
  },

  container: {
    display: 'flex',
    justifyContent: 'space-evenly',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  chartContainer: {
    backgroundColor: '#c19f72',
    borderRadius: '10px',
    padding: '10px 0px',
  },
  heading: {
    fontFamily: 'Chewy !important',
    fontSize: '34px !important',
    color: '#5f3a19 !important',
  },
  description: {
    fontFamily: 'Chewy !important',
    fontSize: '18px !important',
    maxWidth: '500px',
    color: '#685843',
  },
  button: {
    backgroundColor: '#eaac64 !important',
    borderRadius: '10px !important',
    fontSize: '20px !important',
    fontWeight: '700',
    color: '#000000 !important',
    textTransform: 'capitalize !important',
    padding: '25px 125px !important',
    fontFamily: 'Chewy !important',
    '&:hover': {
      backgroundColor: '#F9A85C !important',
    },
  },
  btnContainer: {
    marginTop: '20px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));
